import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, KeepAlive as _KeepAlive, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "factures-container" }
const _hoisted_2 = { class: "main-title" }
const _hoisted_3 = { class: "links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('facture.mainTitle')), 1),
      _createVNode(_component_ReglePastille, { cle: "facturation.definition" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: { path: '/facturation', query: _ctx.$route.query }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('facture.tab.late')), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        to: { path: '/facturation/echeance', query: _ctx.$route.query }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('facture.tab.duesoon')), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        to: { path: '/facturation/payee', query: _ctx.$route.query }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('facture.tab.payed')), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        to: "/facturation/suivi",
        style: {"padding":"8px 16px"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('facture.tab.suivi')), 1)
        ]),
        _: 1
      })
    ]),
    (_openBlock(), _createBlock(_KeepAlive, { include: ['ListFacturesEnRetard', 'ListFacturesAvantEcheance', 'ListFacturesPayees', 'SuiviFinancier'] }, [
      _createVNode(_component_router_view)
    ], 1024))
  ]))
}